import type { SlideDef } from "@/engine/types";
import { offpage } from "./01-offpage";
import { offpagePractice } from "./02-offpage-practice";

export const slides: SlideDef[] = [offpage, offpagePractice];
